import { httpClient } from '../httpClient';

export const authApi = {
  login: (email, password) =>
    httpClient.post('/auth/login', { email, password }),

  me: () =>
    httpClient.get('/auth/me'),

  // H-SELF-1 — self-service profile edit (PUT /auth/me).
  // Body keys other than first_name/last_name/phone/department are
  // silently dropped server-side; do not send password/role/email here.
  updateMe: (data) =>
    httpClient.put('/auth/me', data),

  // H-SELF-3 — self data export.
  exportMe: () =>
    httpClient.get('/auth/me/export'),

  // H-SELF-3 — self account deletion.
  deleteMe: () =>
    httpClient.delete('/auth/me'),

  refresh: (refreshToken) =>
    httpClient.post('/auth/refresh', { refresh_token: refreshToken }),

  logout: () =>
    httpClient.post('/auth/logout'),

  setup2FA: (preToken) =>
    httpClient.post('/auth/2fa/setup', undefined, { token: preToken }),

  confirm2FA: (code, preToken) =>
    httpClient.post('/auth/2fa/confirm', { code }, { token: preToken }),

  verify2FA: (code, type = 'totp', preToken) =>
    httpClient.post('/auth/2fa/verify', { code, type }, { token: preToken }),

  reset2FA: (userId) =>
    httpClient.delete('/auth/2fa', { data: { user_id: userId } }),

  // M-FE-1 — Forgot/Reset password (H-SEC-3 backend wired).
  // Both endpoints are public; backend rate-limits 5/h and 10/h
  // respectively and never reveals whether the email exists.
  forgotPassword: (email) =>
    httpClient.post('/auth/forgot-password', { email }),

  resetPassword: (token, newPassword) =>
    httpClient.post('/auth/reset-password', { token, new_password: newPassword }),

  // Authenticated change-password (current password proof + new).
  changePassword: (currentPassword, newPassword) =>
    httpClient.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    }),

  // ON-14 — mandatory change of an installer-seeded password. Runs on the
  // single-purpose ``password_change_token`` login hands back INSTEAD of a
  // session, so the token is passed explicitly, the same way the 2FA calls
  // pass their pre-2FA token. Server-side policy is identical to
  // changePassword; only the credential authorising the call differs.
  forcePasswordChange: (currentPassword, newPassword, changeToken) =>
    httpClient.post(
      '/auth/force-password-change',
      { current_password: currentPassword, new_password: newPassword },
      { token: changeToken },
    ),

  // H-SELF-5 — caller-scoped activity feed (login + audit-log rows
  // where the user is actor or subject). Optional limit (1..200).
  myActivity: (limit = 50) =>
    httpClient.get('/auth/me/activity', { params: { limit } }),

  // L-4 — mandatory-2FA roles + caller's own enforcement state.
  get2FAPolicy: () =>
    httpClient.get('/auth/2fa/policy'),

  // H-SELF-4 — regenerate the 10 backup codes (TOTP-verified).
  // Returns the plaintext list once; backend stores bcrypt hashes.
  regenerateBackupCodes: (totpCode) =>
    httpClient.post('/auth/2fa/backup-codes/regenerate', { code: totpCode }),

  // M-SELF-3 — verified email-change. The mint endpoint requires
  // a full session; the confirm endpoint takes only the magic-link
  // token (it IS the proof of control of the new address).
  requestEmailChange: (newEmail) =>
    httpClient.post('/auth/me/email-change', { new_email: newEmail }),

  confirmEmailChange: (token) =>
    httpClient.post('/auth/email-change/confirm', { token }),
};
